import { jsxs, jsx } from "react/jsx-runtime";
import { c as clsx } from "../../../chunks/clsx-DgYk2OaC.js";
import { Text } from "../../../foundations/typography/Text/Text.js";
import { spacingHelper } from "../../utility/spacing/spacing.js";
import { getFeedbackIcon } from "../helpers/getFeedbackIcon.js";
import { s as styles, A as AlertContent } from "../../../chunks/AlertContent-x5TL6F0G.js";
const Alert = ({
  children,
  notifyScreenReader,
  titleHeadingLevel = "h3",
  variant = "info",
  title,
  spacings,
  className,
  ...props
}) => {
  if (!title && !children) {
    console.error("You need to pass either a title or children prop for the Alert to render");
  }
  const icon = getFeedbackIcon(variant);
  const shouldNotifySR = notifyScreenReader !== void 0 ? notifyScreenReader : variant === "error";
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: clsx(styles.alert, styles["alert-" + variant], spacingHelper(spacings), className),
      role: shouldNotifySR ? "alert" : "status",
      ...props,
      children: [
        icon,
        /* @__PURE__ */ jsxs("div", { className: styles.alertMain, children: [
          title && typeof title === "string" && /* @__PURE__ */ jsx(
            Text,
            {
              variant: "text-body-head",
              component: titleHeadingLevel || "h3",
              className: styles.alertTitle,
              children: title
            }
          ),
          /* @__PURE__ */ jsx(AlertContent, { children })
        ] })
      ]
    }
  );
};
export {
  Alert
};
